import { render, staticRenderFns } from "./IconFavoriteLinear.vue?vue&type=template&id=0a1a2286&scoped=true"
import script from "./IconFavoriteLinear.vue?vue&type=script&lang=js"
export * from "./IconFavoriteLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a2286",
  null
  
)

export default component.exports